'use strict';
import { App } from './controllers/App';

window.InstanceCollection = window.InstanceCollection || {};

const $jq = window.$jq || jQuery.noConflict();
if (!$jq.ADAC) {
	$jq.ADAC = {};
}
window.$ = jQuery;
const pluginName = 'DamageDeclarationOhcApplication',
	namespace = 'ADAC', fqname = `${namespace}_${pluginName}`;

// The actual plugin constructor
$jq.ADAC[pluginName] = function (element, options, loader) {
	this.tid = options.app.tid;
	this.element = element;
	this.loader = loader;
	this.options = options;
	this.options.$jq = $jq;
	this.$ctx = this.options.$ctx;
	this._name = pluginName;

	// declare public methods
	window.InstanceCollection[pluginName] = this;
	this.application = new App(this.element, this.options, this.loader);
	this.application.start();
};

$jq.fn[fqname] = function (options, loader) {
	return this.each(function () {
		if (!$jq.data(this, fqname)) {
			$jq.data(this,
				fqname,
				new $jq.ADAC[pluginName](this, options, loader));
		}
	});
};

/*! Version: 3.195.0.116265; Commit: ae264c43ca88fe0f2f3182a512c25289c498e485 */
